import {Injectable, OnDestroy} from "@angular/core";
import {EventAnalysisStoreService} from "../../../../store/event-analysis-store.service";
import {BaseStore} from "../../../../store/core/base-store";
import {ChartData} from "chart.js/auto";
import {SankeyDatasetProcessor} from "../utils/sankey-dataset-processor";
import {SalesRepository} from "../../../../repositories/core/sales-repository/sales-repository";
import {LinkedDtoRepository} from "../../../../../common/repositories/linked-dto-repository";
import {EmploymentCostsRepository} from "../../../../repositories/core/employment-costs/employment-costs-repository";
import {ColorMapService} from "../../../../../common/colors/color-map.service";


@Injectable()
export class SankeyStore extends BaseStore implements OnDestroy {
  sankeyDataset!:  ChartData<"sankey">;
  constructor(
    public eventAnalysisStoreService: EventAnalysisStoreService,
    private salesRepository: SalesRepository,
    private linkedDtoRepository: LinkedDtoRepository<any>,
    private employmentCostsRepository: EmploymentCostsRepository,
    private colorMapService: ColorMapService
  ) {
    super(eventAnalysisStoreService);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
  override update() {
    this.sankeyDataset = this.processDataset()
    this.updateNotifier.emit()
  }

  getDataset(): ChartData<"sankey">{
    return this.sankeyDataset
  }

  private processDataset(): ChartData<"sankey"> {
    return SankeyDatasetProcessor.processSankeyChartDataset(this.salesRepository.getSalesWrapper(), this.linkedDtoRepository, this.employmentCostsRepository.getTotalEmployeeCosts(), this.colorMapService, this.eventAnalysisStoreService.revenueCalculationMethodOption);
  }

}
